
import '../App.css';
import Header from '../components/Header';
import EventsVedio from "../components/EventsVedio";
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <EventsVedio/>
    <Footer/>
    </div>
  );
}
export default App;

